import moment from "moment";
import { Colour_Tournament } from "./Utils";

export class ScoreBug {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.name = "ScoreBug";
    this.page = "8096";
    this.data = [];
    this.game = null;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
  }

  async preview({ options }) {
    this.onAir = true;
    let period = options.period;

    this.showClockChallenges = options.showClockChallenges;
    this.game = options.game;

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0006";
      }).value = options.status;

      xml.payload.field.find((item) => {
        return item.attr.name === "0104";
      }).value = options?.game?.home_team?.code || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0105";
      }).value = options?.game?.away_team?.code || "";

      let kit = options.game.home_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0901";
      }).value =
        options?.game?.home_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.home_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0121.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      kit = options.game.away_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0902";
      }).value =
        options?.game?.away_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.away_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0141.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      let home_reds = options.game?.lineup?.home?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);

      let away_reds = options.game?.lineup?.away?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0020"; // HOME RED CARDS
      }).value = 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0021"; // AWAY RED CARDS
      }).value = 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0022"; // HOME RED CARDS
      }).value = home_reds || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0023"; // AWAY RED CARDS
      }).value = away_reds || 0;

      let score = this.getScore(options?.game);
      xml.payload.field.find((item) => {
        return item.attr.name === "0002"; // AWAY RED CARDS
      }).value = score?.home_score || 0;
      xml.payload.field.find((item) => {
        return item.attr.name === "0003"; // AWAY RED CARDS
      }).value = score?.away_score || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0024";
      }).value = "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0025";
      }).value = "0";
      if (period?.number > 2) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "1";
      } else {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "0";
      }
      xml.payload.field.find((item) => {
        return item.attr.name === "0013";
      }).value = "0";

      await this.updateVizPage({
        page: this.page,
        data: xml,
      }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    } else {
      throw new Error("Could not update clock so did not animate it");
    }
  }

  async animate({ options }) {
    this.onAir = true;
    let period = options.period;

    this.showClockChallenges = options.showClockChallenges;
    this.game = options.game;

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

        let curr_value =  xml.payload.field.find((item) => {
                return item.attr.name === "zz009";
       }).value;
               xml.payload.field.find((item) => {
                return item.attr.name === "zz009";
              }).value = curr_value === '0' ? '1' : '0';

      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0006";
      }).value = options.status;

      xml.payload.field.find((item) => {
        return item.attr.name === "0104";
      }).value = options?.game?.home_team?.code || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0105";
      }).value = options?.game?.away_team?.code || "";

      let kit = options.game.home_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0901";
      }).value =
        options?.game?.home_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.home_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0121.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      kit = options.game.away_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0902";
      }).value =
        options?.game?.away_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.away_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0141.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) {}

      let home_reds = options.game?.lineup?.home?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);

      let away_reds = options.game?.lineup?.away?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0020"; // HOME RED CARDS
      }).value = 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0021"; // AWAY RED CARDS
      }).value = 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0022"; // HOME RED CARDS
      }).value = home_reds || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0023"; // AWAY RED CARDS
      }).value = away_reds || 0;

      let score = this.getScore(options?.game);
      xml.payload.field.find((item) => {
        return item.attr.name === "0002"; // AWAY RED CARDS
      }).value = score?.home_score || 0;
      xml.payload.field.find((item) => {
        return item.attr.name === "0003"; // AWAY RED CARDS
      }).value = score?.away_score || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = "1";

      xml.payload.field.find((item) => {
        return item.attr.name === "0024";
      }).value = "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0025";
      }).value = "0";
      if (period?.number > 2) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "1";
      } else {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "0";
      }
      xml.payload.field.find((item) => {
        return item.attr.name === "0013";
      }).value = "0";

          xml.payload.field.find((item) => {
                return item.attr.name === "0201";
              }).value = '0';
  xml.payload.field.find((item) => {
                return item.attr.name === "0203";
              }).value = '';
      if (options.popout)
      {
         xml.payload.field.find((item) => {
                return item.attr.name === "0201";
              }).value = '1';

              xml.payload.field.find((item) => {
                return item.attr.name === "0024";
              }).value = '0';

              xml.payload.field.find((item) => {
                return item.attr.name === "0025";
              }).value = '0';

              let kit =
                options?.popout?.team?._id === options?.game?.home_team?._id
                  ? options?.game.home_team_kit
                  : options?.game.away_team_kit;

              xml.payload.field.find((item) => {
                return item.attr.name === "0202";
              }).value = (options?.popout?.team?.short_name + " " + kit)?.toUpperCase();

              xml.payload.field.find((item) => {
                return item.attr.name === "0203";
              }).value = options?.popout?.text ?? '';
      }

      await this.updateVizPage({
        page: this.page,
        data: xml,
      }).catch((err) => {
        console.log(err);
      });
    }
    this.sendAnimate({ page: this.page });
  }

  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  getScore(game) {
    let try_points = game?.competition?.competition_type === "union" ? 5 : 4;
    let conversion_points =
      game?.competition?.competition_type === "union" ? 2 : 2;
    let penalty_kick_points =
      game?.competition?.competition_type === "union" ? 3 : 2;
    let penalty_try_points =
      game?.competition?.competition_type === "union" ? 7 : 4;
    let drop_goal_points =
      game?.competition?.competition_type === "union" ? 3 : 1;

    let home_score =
      (game?.home_scorers?.filter((g) => g.type === "try").length *
        try_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "conversion").length *
        conversion_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "penalty_kick").length *
        penalty_kick_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "penalty_try").length *
        penalty_try_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "drop_goal").length *
        drop_goal_points || 0);
    let home_tries =
      game?.home_scorers?.filter((g) => g.type === "try").length || 0;
    let home_conv =
      game?.home_scorers?.filter((g) => g.type === "conversion").length || 0;
    let home_pen_kick =
      game?.home_scorers?.filter((g) => g.type === "penalty_kick").length || 0;
    let home_pen_try =
      game?.home_scorers?.filter((g) => g.type === "penalty_try").length || 0;
    let home_drop_goal =
      game?.home_scorers?.filter((g) => g.type === "drop_goal").length || 0;
    let away_score =
      (game?.away_scorers?.filter((g) => g.type === "try").length *
        try_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "conversion").length *
        conversion_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "penalty_kick").length *
        penalty_kick_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "penalty_try").length *
        penalty_try_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "drop_goal").length *
        drop_goal_points || 0);
    let away_tries =
      game?.away_scorers?.filter((g) => g.type === "try").length || 0;
    let away_conv =
      game?.away_scorers?.filter((g) => g.type === "conversion").length || 0;
    let away_pen_kick =
      game?.away_scorers?.filter((g) => g.type === "penalty_kick").length || 0;
    let away_pen_try =
      game?.away_scorers?.filter((g) => g.type === "penalty_try").length || 0;
    let away_drop_goal =
      game?.away_scorers?.filter((g) => g.type === "drop_goal").length || 0;
    return {
      home_score,
      away_score,
      home_tries,
      home_conv,
      home_pen_kick,
      home_pen_try,
      home_drop_goal,
      away_tries,
      away_conv,
      away_pen_kick,
      away_pen_try,
      away_drop_goal,
    };
  }
}
